import focus from "./Focus";
import clickOutside from "./ClickOutside";

export default {
	install(Vue) {
		Vue.directive("focus", focus);
		Vue.directive("clickOutside", clickOutside);
	}
};



// WEBPACK FOOTER //
// ./src/shared/directives/index.ts